import { render, staticRenderFns } from "./CheckDelivery.vue?vue&type=template&id=001838eb&scoped=true"
import script from "./CheckDelivery.vue?vue&type=script&lang=js"
export * from "./CheckDelivery.vue?vue&type=script&lang=js"
import style0 from "./CheckDelivery.vue?vue&type=style&index=0&id=001838eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001838eb",
  null
  
)

export default component.exports